import React from 'react';
import {PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import useWindowSize from '../hooks/useWindowSize';

const COLORS = ['#6fbf73', '#FD8080'];

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const item = payload[0];
        return (
            <div style={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                padding: '8px',
                borderRadius: '4px',
                fontSize: '14px',
            }}>
                <strong>{item.name}</strong><br />
                {item.value.toFixed(1)}%
            </div>
        );
    }
    return null;
};

const CustomLegend = ({ payload, nulos, width,para_contar }) => {
    const isMobile = width < 768;

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, auto)',
                gap: '8px 16px',
                justifyContent: 'center',  // centra el grid como bloque
                justifyItems: 'center',    // centra cada elemento dentro de su celda
                alignItems: 'center',
                marginTop: 10,
            }}
        >
            {payload.map((entry, index) => (
                <div key={`item-${index}`} style={{display: 'flex', alignItems: 'center'}}>
                    <div
                        style={{
                            width: 12,
                            height: 12,
                            backgroundColor: entry.color,
                            marginRight: 6,
                            borderRadius: 2,
                        }}
                    />
                    <span style={{fontSize: '16px', whiteSpace: 'nowrap'}}>
                        {entry.value}: {entry.payload.dato}
                    </span>
                </div>
            ))}
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div
                    style={{
                        width: 12,
                        height: 12,
                        backgroundColor: '#9e9e9e',
                        marginRight: 6,
                        borderRadius: 2,
                    }}
                />
                <span style={{fontSize: '16px', whiteSpace: 'nowrap'}}>
                    Zonas Nulas: {nulos}
                </span>
            </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div
                    style={{
                        width: 12,
                        height: 12,
                        backgroundColor: '#9e9e9e',
                        marginRight: 6,
                        borderRadius: 2,
                    }}
                />
                <span style={{fontSize: '16px', whiteSpace: 'nowrap'}}>
                    Total Zonas a Contar: {para_contar}
                </span>
            </div>
        </div>
    );
};

const GraficoAvanceGeneral = ({datos}) => {
    const [width] = useWindowSize();

    const height = width < 768 ? 150 : 190;
    const outerRadius = width < 768 ? 15 : 50;
    const innerRadius = width < 768 ? 5 : 30;

    if (!datos || datos.length === 0) {
        return <p>Cargando datos...</p>;
    }

    const general = datos.find(row => row.ubicacion_path === 'GENERAL');
    if (!general) return null;

    const total = general.tag_total || 0;
    const nulos = general.tag_nulo || 0;
    const contados = general.tag_contado || 0;
    const para_contar = total - nulos

    const divisor = total - nulos;
    const porcentaje = divisor > 0 ? (contados / divisor) * 100 : 0;

    const data = [
        {name: 'Zonas Contadas', value: porcentaje, dato: contados},
        {name: 'Zonas Pendientes', value: 100 - porcentaje, dato: total - contados - nulos}];

    return (
        <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign:'center',
            padding:10}}>
            <h3 style={{margin: 10}}>Avance General (%)</h3>
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height}}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={outerRadius}
                            innerRadius={innerRadius}>
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip/>}/>
                        <Legend content={(props) => (<CustomLegend {...props} nulos={nulos} width={width} para_contar={para_contar}/>)}/>
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );};

export default GraficoAvanceGeneral;